<template>
    <v-row class="bod_back_img">
        <v-col cols="12">

            <v-row justify="center" align="center" :style="search_background">
                <v-col>
                    <v-row align="center" justify="center">

                        <v-col cols="2" offset="1">
                            <v-textarea
                                clearable
                                filled
                                background-color="white"
                                label="List of target genes"
                                placeholder="e.g. MOR,AC,VGCC"
                                no-resize
                                hide-details
                                rows="4"
                                v-model="geneVals"
                                ></v-textarea>
                            <v-file-input
                                class="mt-2"
                                v-model="upload_file_gene"
                                placeholder="File upload"
                                background-color="white"
                                hide-details
                                outlined
                                dense
                                prepend-icon
                                prepend-inner-icon="mdi-paperclip"
                                ></v-file-input>
                        </v-col>

                        <v-col cols="2">
                            <v-textarea
                                clearable
                                filled
                                background-color="white"
                                label="List of microRNAs"
                                placeholder="e.g. hsa-miR-134-5p,hsa-miR-103a-3p"
                                no-resize
                                hide-details
                                rows="4"
                                v-model="mirnaVals"
                                ></v-textarea>
                            <v-file-input
                                class="mt-2"
                                v-model="upload_file_mirna"
                                placeholder="File upload"
                                background-color="white"
                                hide-details
                                outlined
                                dense
                                prepend-icon
                                prepend-inner-icon="mdi-paperclip"
                                ></v-file-input>
                        </v-col>

                        <v-col cols="2">
                            <v-textarea
                                clearable
                                filled
                                background-color="white"
                                label="List of LncRNAs"
                                placeholder="e.g. FTX,RFPL1S"
                                no-resize
                                hide-details
                                rows="4"
                                v-model="lncrnaVals"
                                ></v-textarea>
                            <v-file-input
                                class="mt-2"
                                v-model="upload_file_lncrna"
                                placeholder="File upload"
                                background-color="white"
                                hide-details
                                outlined
                                dense
                                prepend-icon
                                prepend-inner-icon="mdi-paperclip"
                                ></v-file-input>
                        </v-col>

                        <v-col cols="1">
        
                            <v-btn
                            rounded
                            class="text-none"
                            color="#31a3a2"
                            dark
                            :to="goToSearch"
                            >Search</v-btn>
                            <!-- >Multi-Search</v-btn> -->
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>

            <p class="mt-5 mx-auto solid_width">
                You can enter a single gene/noncoding RNA,  multiple genes/noncoding RNA or multiple types of gene/noncoding RNA, and click search.
                <br/>The File upload option requires the user to pass a .txt format, separated by commas or newlines.
            </p>

            <v-row justify="center" class="ma-16">
                <v-col align-self="center">

                    <v-card style="max-width: 1440px;margin: auto;">
                        <v-card-title class="blue-grey lighten-5 pa-0" style="height: 54px;align-content: center;justify-content: center;">
                            <div :style="icon_back"></div>
                            <span style="font-size: 24px;">Search</span>
                        </v-card-title>

                        <v-row justify="center">
                            <v-col cols="5" align-self="center" style="max-height: 600px;padding-top:30px;padding-left:200px;">
                                <v-img :src="search_gene_img" height="400" width="350"></v-img>
                            </v-col>
                            <v-col cols="5" align-self="start" class="mt-16">
        
                                <v-row>
                                    <v-col>
                                        <v-img :src="search_box" width="284" height="46"></v-img>
                                    </v-col>
                                </v-row>
        
                                <v-row justify="center">
                                    <v-col cols="2">
                                        <p class="text-h6" style="width:85px;">Example.</p>
                                    </v-col>
                                    <v-col class="px-0">
                                        <v-row v-for="exa in examples" :key="exa.text" no-gutters justify="center" align="center">
                                            <v-col cols="3">{{exa.title}}</v-col>
                                            <v-col class="text text-left">
                                                <template v-for="btn in exa.btns">
                                                    <span class="text-none px-1 primary--text" :key="btn">{{btn}}</span>
                                                </template>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
        
                                <v-card-actions>
                                    <v-btn
                                    rounded
                                    @click="example_click"
                                    class="text-none white--text"
                                    color="#31a3a2">
                                    Run example
                                    </v-btn>
                                </v-card-actions>
        
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="6" align-self="center">
                                <p class="text-justify text--secondary mb-0">The following information is displayed on Enrichment analysis result page.</p>
                            </v-col>
                        </v-row>
        
                        <v-row justify="center">
                            <v-col cols="6" align-self="center" :style="step_background" style="margin-bottom: 60px;">
                                <p class="text-justify my-3"><span class="font-italic">01.</span>The significance signal pathway names and P-values/P-adjust of the input gene/miRNA/lncRNA.</p>
                                <p class="text-justify my-3"><span class="font-italic">02.</span>The number of them is significance signal pathways and specific gene list of intersecting genes.</p>
                                <p class="text-justify my-3"><span class="font-italic">03.</span>The number of input gene/miRNA/lncRNA.</p>
                                <p class="text-justify my-3"><span class="font-italic">04.</span>The visualization results of the enrichment analysis, such as bubble charts and histograms</p>
                                <!-- <p class="text-justify my-1"><span class="font-italic">05.</span> The number of input miRNA</p> -->
                                    
                            </v-col>
                        </v-row>
                    </v-card>
        
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
export default {
    data: () => ({

        geneVals: "",
        mirnaVals: "",
        lncrnaVals: "",

        upload_file_gene: null,
        upload_file_mirna: null,
        upload_file_lncrna: null,

        examples: [
            {"title": "MiRNA name", "btns": ["hsa-miR-125b-5p", "hsa-miR-25-3p"]},
            {"title": "LncRNA name", "btns": ["CTBP1-AS", "HOTAIR"]},
            {"title": "Gene name", "btns": ["P53", "PDH"]},
            // {"title": "cirRNA name", "btns": ["P53", "PDH"]},
        ],
        search_box: "static/search_box.png",
        search_icon: "static/search_icon.png",
        search_gene_img: "static/img_enrichment/enrichment_gene.png",
        search_background: {
            "backgroundImage": "url('static/img_enrichment/enrichment_bakcground.png')",
            "background-repeat":"no-repeat",
            "height": "238px",
            "text-align": "center"
        },
        step_background: {
            "backgroundImage": "url('static/img_enrichment/enrichment_steps.png')",
            "background-repeat":"no-repeat",
            "background-size": '100%',
            "height": "246px",
            "text-align": "center"
        }
    }),

    methods: {
        example_click: function(){

            this.mirnaVals = this.examples[0].btns.join(',');
            this.lncrnaVals = this.examples[1].btns.join(',');
            this.geneVals = this.examples[2].btns.join(',');
            this.$router.push(this.goToSearch);
        },
        readFile: function(file, target){
            if(!file) return null
            let reader = new FileReader();
            reader.addEventListener("load", () => {
                this[target] += reader.result;
            }, false);
            reader.readAsText(file, 'utf8')
        },
    },
    watch: {
        upload_file_gene: function(nVal, oVal){
            if(!nVal) return
            this.readFile(nVal, "geneVals")
        },
        upload_file_mirna: function(nVal, oVal){
            if(!nVal) return
            this.readFile(nVal, "mirnaVals")
        },
        upload_file_lncrna: function(nVal, oVal){
            if(!nVal) return
            this.readFile(nVal, "lncrnaVals")
        },
    },
    computed: {
        icon_back: function(){
            return {
                "backgroundImage": "url('" +this.search_icon+ "')",
                "background-repeat":"no-repeat",
                "height": "28px",
                "width": "28px",
                "background-size": '100%',
                "text-align": "center"
            }
        },
        goToSearch: function(){
            return {
                name: 'EnrichmentDetail', 
                query: {
                    geneVals: this.geneVals,
                    mirnaVals: this.mirnaVals,
                    lncrnaVals: this.lncrnaVals,
                }
            }
        }
    }
}
</script>